import React from 'react';
import {
  IconButton,
  TextField as MuiTextField,
  InputProps as StandardInputProps,
  InputBase,
  FilledTextFieldProps,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { cleanNumberMask, numberMask } from 'helper';
import './styles.scss';

export interface ITextFieldProps extends Omit<FilledTextFieldProps, 'variant'> {
  variant?: 'filled' | 'default';
  mask?: string;
  naked?: boolean;
  clear?: boolean;
  onClickClear?: () => void;
}

const TextField: React.FC<ITextFieldProps> = ({
  onChange,
  mask,
  naked = false,
  clear = false,
  onClickClear,
  InputProps,
  ...rest
}) => {
  const onChangeTextField = (e: any) => {
    if (mask) {
      e.target.value = numberMask(cleanNumberMask(e.target.value), mask);
    }

    if (onChange) {
      onChange(e);
    }
  };

  const inputProps: Partial<StandardInputProps> = {
    ...InputProps,
  };

  if (clear) {
    inputProps.endAdornment = clear ? (
      <IconButton size="small" onClick={onClickClear!}>
        <Close style={{ opacity: 0.5 }} />
      </IconButton>
    ) : null;
  }

  if (naked) {
    return (
      <InputBase autoComplete="off" value={rest.value} defaultValue={rest.defaultValue} onChange={onChangeTextField} />
    );
  }

  return (
    <MuiTextField
      {...rest}
      classes={{ root: 'mui-text-field' }}
      autoComplete="off"
      onChange={onChangeTextField}
      InputProps={{ ...inputProps }}
      variant={rest.variant === 'default' ? undefined : rest.variant || 'filled'}
    />
  );
};

export default TextField;
